/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class TranslationDialog extends SiteEntityDialog<TranslationRow, any> {
        protected getFormKey() { return TranslationForm.formKey; }
        protected getIdProperty() { return TranslationRow.idProperty; }
        protected getLocalTextPrefix() { return TranslationRow.localTextPrefix; }
        protected getNameProperty() { return TranslationRow.nameProperty; }
        protected getService() { return TranslationService.baseUrl; }

        protected form = new TranslationForm(this.idPrefix);
    }
}